import { useTranslation } from "react-i18next";

export default function InfoEvents() {
  const { t } = useTranslation();

  const infos = [
    { icon: "ri-t-shirt-line", text: t("info_1") },
    { icon: "ri-car-line", text: t("info_2") },
    { icon: "ri-restaurant-line", text: t("info_3") },
    { icon: "ri-time-line", text: t("info_4") },
    { icon: "ri-suitcase-line", text: t("info_5") },
  ];

  return (
    <section id="activities" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="rounded-lg overflow-hidden border border-background-200 min-h-[320px]">
          <iframe
            title="Bali VW Tour Location"
            src="https://www.google.com/maps?q=Jalan%20Ganetri%209%20D%2C%20Gatot%20Subroto%20Timur%2C%20Denpasar%2080235%2C%20Bali%2C%20Indonesia&z=17&output=embed"
            className="w-full h-full min-h-[320px] border-0"
            loading="lazy"
          ></iframe>
        </div>

        <div className="bg-background-100 border border-background-200 rounded-lg p-8">
          <div className="eyebrow-brand text-sm md:text-base uppercase tracking-[0.3em] mb-3">— {t("info_title")} —</div>
          {t("info_heading") ? (
            <h3 className="font-heading text-2xl text-foreground-950 mb-5">{t("info_heading")}</h3>
          ) : null}
          <ul className="space-y-4">
            {infos.map((it) => (
              <li key={it.text} className="flex gap-3 text-sm text-foreground-800">
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 flex-shrink-0">
                  <i className={it.icon}></i>
                </span>
                <span className="leading-relaxed whitespace-pre-line">{it.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}